var _style, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 19.9 20",
    style: {
      enableBackground: "new 0 0 19.9 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FCFCFC;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.9,11h-2c-0.6,0-1-0.4-1-1c0-0.4,0.3-0.8,0.6-0.9L9.9,2.4L3.3,9.1C3.7,9.2,3.9,9.6,3.9,10c0,0.6-0.4,1-1,1 h-2c-0.4,0-0.8-0.2-0.9-0.6C-0.2,10-0.1,9.6,0.2,9.3l9-9c0.4-0.4,1-0.4,1.4,0l9,9c0.3,0.3,0.4,0.7,0.2,1.1 C19.7,10.8,19.3,11,18.9,11z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.9,20h-10c-1.7,0-3-1.3-3-3v-7c0-0.6,0.4-1,1-1s1,0.4,1,1v7c0,0.6,0.4,1,1,1h10c0.6,0,1-0.4,1-1v-7 c0-0.6,0.4-1,1-1s1,0.4,1,1v7C17.9,18.7,16.6,20,14.9,20z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.9,20c-0.6,0-1-0.4-1-1v-6c0-0.6-0.4-1-1-1h-2c-0.6,0-1,0.4-1,1v6c0,0.6-0.4,1-1,1s-1-0.4-1-1v-6 c0-1.7,1.3-3,3-3h2c1.7,0,3,1.3,3,3v6C13.9,19.6,13.5,20,12.9,20z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.1248ad7de13f07ebc108f7abf27c733c.svg";
export { ForwardRef as ReactComponent };